import { Space } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import TagsList from "components/TagsList";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import FormField from "ds/components/Form/Field";
import { BlueprintVersionedGroup } from "types/generated";
import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import DrawerSimple from "ds/components/DrawerNew/Simple";

type TemplateDetailsProps = {
  item: BlueprintVersionedGroup;
  onEdit?: () => void;
};

const TemplateDetailsDrawer = createDrawer(({ item }: TemplateDetailsProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(item.description);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Template details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="Name" value={item.name} />

        <FormField label="Space">
          <MetaInfoListItem
            icon={Space}
            linkText={item.space.name}
            href={`/spaces/${item.space.id}`}
          />
        </FormField>

        <DescriptionDetails
          description={item.description}
          onOpenFullDescription={onOpenFullDescription}
        />

        {item.labels.length > 0 && (
          <FormField label="Labels">
            <TagsList tags={item.labels} alwaysExpanded />
          </FormField>
        )}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showTemplateDetailsDrawer = createDrawerTrigger(TemplateDetailsDrawer);
